module.exports = __webpack_public_path__ + "img/integrated-software-services-new.97b2adfb.png";